import { ActivatedRoute, Router } from '@angular/router';
import { SidebarItem } from '../../core/components/layout/sidebar/contract/sidebar-item.contract';

export function navigateToFirstNestedScreen(router: Router, item: SidebarItem, activatedRoute?: ActivatedRoute): void {
  if (!(item.expanded) && item.items && item.items.length > 0) {
    const firstNestedScreen = item.items[0];
    if (firstNestedScreen.routerLink) {
      if (activatedRoute) {
        router.navigate([firstNestedScreen.routerLink], { relativeTo: activatedRoute });
      } else {
        router.navigate([firstNestedScreen.routerLink]);
      }
    }
  }
}
